<section class="field">
  <label *ngIf="label" class="mb-2">{{ label }}</label>

  <div
    class="px-3 py-5 w-full border-1 border-dashed border-gray-300 text-center relative w-full"
    appDnd
    (fileDropped)="uploadFile($event)"
  >
    <section class="h-full flex justify-content-center align-items-center">
      <input
        type="file"
        #fileDropRef
        class="cursor-pointer opacity-0 absolute z-2 w-full h-full top-0 left-0"
        id="fileDropRef"
        multiple
        (change)="uploadFile($event)"
      />
      <div>
        <i class="pi pi-file text-gray-300 font-light text-2xl mb-2"></i>
        <p><span class="text-blue-500">Upload a file</span> or drag and drop</p>
        <p class="text-gray-400 mt-1">
          <ng-container *ngFor="let type of fileType">
            {{ type | uppercase }}
          </ng-container>
          up to {{ fileSize }}MB
        </p>
      </div>
    </section>
  </div>

  <div class="py-3" *ngIf="showImagesPreview">
    <ng-container *ngIf="sortable; else elseTemplate">
      <!-- ! Iz div-a ispod
        [sortablejs]="fileList"
        [sortablejs]="
          uploadFormField ??
          CustomUtils.getLangAttachments(formGroup, appConfig.languages[0].code)
        " -->
      <div>
        <div
          *ngFor="let item of fileList; let imgIndex = index"
          class="mb-2 flex align-items-center justify-content-between border-1 border-transparent border-round p-2 hover:border-gray-100 transition-all transition-duration-300 cursor-pointer"
        >
          <main class="flex w-full align-items-center">
            <ng-container *ngIf="uploadType === 'image'; else elseTemplate">
              <img
                class="w-3rem border-round mr-2"
                [src]="cleanURL(item.imageLocalUrl)"
                alt=" "
              />
            </ng-container>
            <ng-template #elseTemplate>
              <i class="pi pi-file text-2xl mr-2"></i>
            </ng-template>

            <span *ngIf="!includeSeo">{{ item.fileName }}</span>
          </main>
          <span
            type="button"
            pTooltip="Obriši"
            tooltipPosition="top"
            class="p-1 text-sm text-pink-400"
            (click)="removeFile($event, imgIndex, item.fileName)"
          >
            <i class="pi pi-trash"></i>
          </span>
        </div>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <!-- ! Iz DIV-a ispod [sortablejs]="fileList" -->
      <div>
        <div
          *ngFor="let item of fileList; let imgIndex = index"
          class="mb-2 flex align-items-center justify-content-between"
        >
          <main class="main-description">
            <div class="reorder-handle responsive-handle mr-2">
              <i class="pi pi-sort"></i>
            </div>
            <ng-container *ngIf="uploadType === 'image'; else elseTemplate">
              <img
                class="w-4rem border-round mr-2"
                [src]="cleanURL(item.imageLocalUrl)"
                alt=" "
              />
            </ng-container>
            <ng-template #elseTemplate>
              <i class="pi pi-file mr-2"></i>
            </ng-template>

            <h4 *ngIf="!includeSeo">{{ item.fileName }}</h4>
          </main>
          <button
            type="button"
            pTooltip="Obriši"
            tooltipPosition="top"
            class="second-btn small-btn mr-2"
            (click)="removeFile($event, imgIndex, item.fileName)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</section>
<app-help-message
  *ngIf="helpMessage"
  [message]="helpMessage"
></app-help-message>
